
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'

import Moment from 'moment'
import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    setup (props, context) {
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $store = useStore()
        const list = ref<any[]>([])
        const isLoading = ref<boolean>(true)

        const getList = () => {
            _this.proxy.$request('/lottery/prize/list', {
                aid: $store.state.aid,
                userinfo: $store.state.userInfo
            }, 'post').then((data: any) => {
                list.value = data.list
                nextTick(() => {
                    COVER.pageLoaded()
                    isLoading.value = false
                })
            }).catch((res) => {
                COVER.pageLoaded()
                isLoading.value = false
            })
        }

        const order = (pid: string, index: number) => {
            _this.proxy.$request('/lottery/blh/order', {
                aid: $store.state.aid,
                pid,
                userinfo: $store.state.userInfo
            }, 'post').then((data) => {
                list.value[index].state = 2
            }).catch((res) => {
                if (!res || res.errno != 1010) {
                    COVER.toast('领取券码失败，请在点击一次查看')
                }
            })
        }

        const viewCode = (pid: string, index: number) => {
            _this.proxy.$request('/lottery/blh/sms', {
                aid: $store.state.aid,
                pid,
                userinfo: $store.state.userInfo
            }, 'post').then((data) => {
                COVER.toast('您的中奖券码将在48小时内通过短信发送至您的手机，请在手机短信内查看兑换码。')
            }).catch((res) => {
                if (res && res.errno == 1010) {
                    return
                }
                if (res && res.errmsg) {
                    COVER.toast(res.errmsg)
                } else {
                    COVER.toast('查看券码失败，请在点击一次查看')
                }   
            })
        }

        const filterTime = (time: number) => {
            if (!time) {
                return ''
            }
            return Moment(time).format('YYYY.MM.DD')
        }

        onMounted(() => {
            COVER.track('load', '中奖纪录页')
            COVER.onshare($store.state.shareData)
            getList()
        })    

        return {
            list,
            isLoading,
            filterTime,
            order,
            viewCode
        }
    }
})
